function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.83108 10.4336C5.39233 10.4336 5.02197 10.9159 5.02197 11.4861C5.02197 12.0568 5.39228 12.5391 5.83108 12.5391C6.26983 12.5391 6.64061 12.0568 6.64061 11.4861C6.64061 10.9159 6.26983 10.4336 5.83108 10.4336Z",
  fill: "#7C818C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9263 16C12.4875 16 12.1172 16.4823 12.1172 17.053C12.1172 17.6232 12.4875 18.1055 12.9263 18.1055C13.365 18.1055 13.7359 17.6232 13.7359 17.053C13.7359 16.4823 13.365 16 12.9263 16Z",
  fill: "#7C818C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5243 7.47133C10.3954 0.925201 10.76 1.17523 10.1932 0.955514C9.3878 0.63667 8.42939 0.803389 7.76737 1.41114L1.1677 7.47133C0.425625 8.15243 0 9.12168 0 10.1312V20.8627C0 22.1271 1.02567 23.1562 2.28614 23.1562H16.4053C17.6658 23.1562 18.6915 22.1271 18.6915 20.8627V10.1312C18.6915 9.12168 18.2658 8.15243 17.5243 7.47133ZM8.66555 5.17075C8.70816 4.76293 9.08297 4.47332 9.50231 4.55187C9.90338 4.63532 10.1293 5.01937 10.0545 5.37704C9.97505 5.7581 9.61584 6.00084 9.22762 5.9281C8.85684 5.85091 8.63053 5.51476 8.66555 5.17075ZM3.61556 11.4849C3.61556 10.1307 4.60936 9.02906 5.83097 9.02906C7.05305 9.02906 8.0468 10.1307 8.0468 11.4849C8.0468 12.8392 7.053 13.9413 5.83097 13.9413C4.60936 13.9413 3.61556 12.8392 3.61556 11.4849ZM7.64648 18.9536C7.14961 18.9536 6.80283 18.4453 6.99867 17.9802L10.4216 9.8388C10.572 9.48141 10.9841 9.31301 11.3422 9.46317C11.7003 9.61286 11.8686 10.0245 11.7186 10.3819L8.29523 18.5233C8.18227 18.7918 7.92164 18.9536 7.64648 18.9536ZM12.9262 19.5075C11.7045 19.5075 10.7108 18.4059 10.7108 17.0516C10.7108 15.6974 11.7046 14.5953 12.9262 14.5953C14.1478 14.5953 15.142 15.6974 15.142 17.0516C15.142 18.4059 14.1478 19.5075 12.9262 19.5075Z",
  fill: "#7C818C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8236 15.1761C21.5343 8.52541 20.2627 4.82764 20.2446 4.78563C19.8467 3.86596 19.0732 3.15072 18.1235 2.82373C18.069 2.80525 18.3905 2.88319 13.291 1.67578L18.476 6.43692C19.5068 7.38279 20.0979 8.72862 20.0979 10.1296V19.2234L22.6274 18.1428C23.7716 17.6489 24.3036 16.3227 23.8236 15.1761Z",
  fill: "#7C818C"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgKupon = function SvgKupon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKupon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kupon.e8dcacb1.svg";
export { ForwardRef as ReactComponent };